import React from "react";
import webui, { BaseComponent } from "@tinqin/tinqin-web-ui";
import ResponsiveHOC from "../../HOC/components/responsive";
import { xssFilter } from "../../common/utils/xssFilter";
//title component ("bannerTitle" and "title" combined, uses "value" for content)
//uses dangerouslySetInnerHTML for rich titles
//tag, extraClasses, value
//overwriteClasses to overwrite default tq-title class
class RestrictedRichTitle extends BaseComponent {
    constructor(props) {
        super(props);

        this.state = {
            textHeight: "0px"
        };

        this.text = React.createRef();
    }

    componentDidMount() {
        this.restrictText();
    }

    componentDidUpdate() {
        this.restrictText();
    }

    restrictText() {
        if (this.text.current) {
            const props = this.getProps();
            const lineHeightStyle = window
                .getComputedStyle(this.text.current, null)
                .getPropertyValue("line-height");
            const lineHeight = parseFloat(lineHeightStyle);
            const textHeight = `${lineHeight * props.allowedLines}px`;
            if (textHeight !== this.state.textHeight) {
                this.setState({ textHeight: `${lineHeight * props.allowedLines}px` });
            }
        }
    }

    onClick = () => {
        this.dispatchSirenActions();
    };

    getProps() {
        return webui.getUtils().extractComponentProps(this.props, {
            additionalProps: [
                "value",
                "extraClasses",
                "tag",
                "overwriteClasses",
                "sizes",
                "allowedLines"
            ],
            propsDefaults: {
                extraClasses: "",
                tag: "h2",
                value: "",
                allowedLines: 2
            },
            aliases: {
                value: "label"
            }
        });
    }

    render() {
        const data = this.props.data ? this.props.data.properties || {} : null;
        if (!data) {
            return "";
        }
        const dataProps = this.getProps();
        let className = `tq-title ${dataProps.extraClasses}`;
        if (dataProps.overwriteClasses) {
            className = dataProps.overwriteClasses;
        }
        //removing any paragraphs
        const removedParagraphsValue = dataProps.value.replace("<p>", "").replace("</p>", "");
        return React.createElement(
            dataProps.tag,
            { className, onClick: this.onClick },
            <span
                ref={this.text}
                style={{
                    height: this.state.textHeight,
                    overflow: "hidden"
                }}
                className="tq-text-node"
                dangerouslySetInnerHTML={{
                    __html: xssFilter.process(removedParagraphsValue)
                }}
            ></span>
        );
    }
}

//using additional wrapper in order to take configuration of responsiveContainer
//and apply it to the ResponsiveHOC
function ResponsiveHOCWrapper(props) {
    const dataProps = webui.getUtils().extractComponentProps(props, {
        additionalProps: ["sizes"]
    });
    const sizesOptions = dataProps.sizes ? { sizes: dataProps.sizes } : undefined;
    const HOCComponent = ResponsiveHOC(RestrictedRichTitle, sizesOptions);
    return <HOCComponent {...props}></HOCComponent>;
}

export default webui.connectComponent({
    actions: { dispatchSirenActions: "siren.dispatchSirenActions" }
})(ResponsiveHOCWrapper);
